// AdminMenu.jsx
import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons";
import { Menu } from "antd";
import Cookies from "js-cookie";
import { find, last } from "lodash";
import { useEffect, useState } from "react";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import { ROUTE } from "routes/route";
import "./styles.scss";

const items = [
  {
    key: ROUTE.ADMIN.PATIENTS,
    label: "患者情報",
  },
  {
    key: ROUTE.ADMIN.CLINIC,
    label: "クリニック情報",
  },
  {
    key: ROUTE.ADMIN.ARTICLES,
    label: "記事一覧",
    children: [
      {
        key: ROUTE.ADMIN.ARTICLES_CREATE,
        label: "記事を作成する",
      },
    ],
  },
  {
    key: ROUTE.ADMIN.HELP,
    label: "ヘルプ一覧",
    children: [
      {
        key: ROUTE.ADMIN.HELP_CREATE,
        label: "ヘルプ記事を作成する",
      },
    ],
  },
  {
    key: ROUTE.ADMIN.NOTICES,
    label: "お知らせ一覧",
    children: [
      {
        key: ROUTE.ADMIN.NOTICES_CREATE,
        label: "お知らせを作成する",
      },
    ],
  },
  {
    key: ROUTE.ADMIN.SETTING,
    label: "各種設定",
    children: [
      {
        key: ROUTE.ADMIN.SETTING_THRESHOLD,
        label: "各種しきい値設定",
      },
      {
        key: ROUTE.ADMIN.SETTING_PASSWORD,
        label: "パスワード設定",
      },
      {
        key: ROUTE.ADMIN.SETTING_DEVICE,
        label: "お知らせライト管理一覧",
      },
      {
        key: ROUTE.ADMIN.SETTING_CERTIFICATE,
        label: "SSL証明書の有効期限",
      },
    ],
  },
  {
    key: ROUTE.PUBLIC.LOGOUT,
    label: "ログアウト",
  },
];

const AdminMenu = ({ isInDrawer = false, onCloseDrawer }) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const [openKeys, setOpenKeys] = useState([]);

  const onClick = ({ key }) => {
    if (key === "/logout") {
      localStorage.clear();
      Cookies.remove("USER_INFO");
      Cookies.remove("access_token");
      Cookies.remove("refresh_token");
      window.location.href = ROUTE.PUBLIC.LOGIN;
      return;
    }
    history.push(key);
    if (isInDrawer && onCloseDrawer) {
      onCloseDrawer();
    }
  };

  const onOpenChange = (keys) => {
    const excludePaths = [ROUTE.ADMIN.SETTING];
    if (!keys.length) {
      const currentMenu = find(
        items,
        (item) =>
          item.key === pathname ||
          item.children?.some((child) => child.key === pathname)
      );
      if (currentMenu && !excludePaths.includes(currentMenu.key)) {
        history.push(currentMenu.key);
        setOpenKeys([currentMenu.key]);
      } else {
        setOpenKeys([]);
      }
    } else {
      if (!excludePaths.includes(last(keys))) {
        history.push(last(keys));
      }
      setOpenKeys(keys);
    }
  };

  useEffect(() => {
    const currentMenu = find(
      items,
      (item) =>
        item.key === pathname ||
        item.children?.some((child) => child.key === pathname)
    );
    if (currentMenu) {
      setOpenKeys([currentMenu.key]);
    }
  }, [pathname]);

  return (
    <div className={`menu-content ${isInDrawer ? "drawer" : ""}`}>
      {!isInDrawer && (
        <div className="home-left-logo">
          <img
            src="/icons/logo.webp"
            className="logo-icon"
            onClick={() => history.replace("/admin/patients")}
          />
        </div>
      )}
      <div className="home-left-info">
        <Menu
          selectedKeys={[pathname]}
          openKeys={openKeys}
          mode="inline"
          theme="light"
          items={items}
          expandIcon={(e) => (!e.isOpen ? <CaretDownOutlined /> : <CaretUpOutlined />)}
          onClick={onClick}
          onOpenChange={onOpenChange}
        />
      </div>
    </div>
  );
};

export default AdminMenu;
